import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { fr } from "../content/fr";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DRAFT = "viralya-order-draft";

export default function Pilote() {
  const navigate = useNavigate();
  const [form, setForm] = useState(() => {
    try { return JSON.parse(localStorage.getItem(DRAFT)) || { nom: "", email: "", entreprise: "", telephone: "" }; }
    catch { return { nom: "", email: "", entreprise: "", telephone: "" }; }
  });
  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));
  const f = fr.pilote.fields;

  const onSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem(DRAFT, JSON.stringify(form));
    navigate("/commande/pilote");
  };

  return (
    <div>
      <Seo routeKey="/pilote" />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <div className="steps-bar"><div className="step active" /><div className="step" /><div className="step" /></div>
          <span className="eyebrow"><span className="sq" />{fr.pilote.eyebrow}</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>{fr.pilote.title}</h1>
          <p className="lead" style={{ marginBottom: "2rem" }}>{fr.pilote.subtitle}</p>

          <form className="glass card" onSubmit={onSubmit} data-testid="pilote-form">
            <div className="form-grid">
              <div className="field"><label htmlFor="p-nom">{f.nom}</label><input id="p-nom" required value={form.nom} onChange={update("nom")} data-testid="pilote-nom" /></div>
              <div className="field"><label htmlFor="p-email">{f.email}</label><input id="p-email" type="email" required value={form.email} onChange={update("email")} data-testid="pilote-email" /></div>
              <div className="field"><label htmlFor="p-ent">{f.entreprise}</label><input id="p-ent" value={form.entreprise} onChange={update("entreprise")} data-testid="pilote-entreprise" /></div>
              <div className="field"><label htmlFor="p-tel">{f.telephone}</label><input id="p-tel" value={form.telephone} onChange={update("telephone")} data-testid="pilote-telephone" /></div>
            </div>
            <button type="submit" className="btn btn--primary" style={{ marginTop: "1.6rem" }} data-testid="pilote-next">
              {fr.pilote.next} <ArrowRight size={16} />
            </button>
          </form>
          <p className="muted" style={{ marginTop: "1.2rem", fontSize: "0.85rem" }} data-testid="pilote-reassurance">Vos leads qualifiés arrivent dans <a href="https://app.loomy-crm.com" target="_blank" rel="noopener" className="inline-link">Loomy CRM</a> pour la vente ; les relances par appel passent par <a href="https://talk-flow.ai" target="_blank" rel="noopener" className="inline-link">Talk-Flow</a>.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
